'use strict';
const axios = require('axios');

const TASKMANAGER_URL = `${window.location.protocol}//${window.location.hostname}:3023`;

const taskManagerAxios = axios.create({
    baseURL: `${TASKMANAGER_URL}/task-manager`,
});

taskManagerAxios.interceptors.request.use((config) => {
    config.headers['x-api-key'] = window.taskManagerApiKey ?? '';
    return config;
});

module.exports = { taskManagerAxios, TASKMANAGER_URL };
